<template>
    <df-app no-padding title="Benutzerverwaltung">
        <template slot="aside" v-if="rows">
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('default')"/>
                <component :is="navItem('coaches')"/>
            </ul>
            <div class="aside-compose"><router-link :to="{ name: 'create-user' }" class="btn btn-lg btn-primary btn-block">Benutzer hinzufügen</router-link></div>
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('admins')"/>
                <component :is="navItem('other')"/>
                <component :is="navItem('archived')"/>
            </ul>
        </template>

        <router-view :rows="filteredRows" :title="title" :icon="icon" @reload="load" @update="update" v-if="rows"/>
    </df-app>
</template>

<script>
    import admin from '../../../mixins/admin';
    import User from '../../../models/User';

    export default {
        mixins: [admin],

        data: () => ({
            Model: User,

            route: 'admin-users',
            filters: {
                default: { title: 'Alle Benutzer', icon: 'accounts-list-alt', filter: u => !u.archived },
                coaches: {
                    title: 'Coaches',
                    icon: 'assignment-account',
                    filter: u => (!u.archived && u.roles.includes('ROLE_COACH')),
                },
                admins: {
                    title: 'Administratoren',
                    icon: 'accounts-alt',
                    filter: u => (!u.archived && u.isAdmin),
                },
                other: {
                    title: 'Andere Benutzer',
                    icon: 'graduation-cap',
                    filter: u => (!u.archived && !u.hasRole('ROLE_COACH')),
                },
                archived: { title: 'Archivierte Benutzer', icon: 'archive', filter: u => u.archived },
            },
        }),
    };
</script>
